import React from "react"
import badge from "badges/making-questions.svg"
import { BadgeImage } from "backpack/badges/styled"

const MakingQuestions = props => <BadgeImage src={badge} {...props} />

export default MakingQuestions
